<template>
  <div class="rss-item">
    <div class="left">
      <fa icon="calendar-alt"></fa>
      <div class="date">{{ data.date }}</div>
      <div class="author">By {{ data.author }}</div>
    </div>
    <div class="right">
      <a class="title" :href="data.link" target="_blank">{{ data.title }}</a>
      <div class="content">{{ data.description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data']
};
</script>

<style scoped lang="scss">
.rss-item {
  display: flex;
  min-height: 100px;
  margin: 5px;
  padding-bottom: 5px;

  .left {
    width: 150px;
    padding: 5px;

    .date {
      font-weight: 600;
    }

    .author {
      font-size: 0.8rem !important;
      color: $gray;
    }
  }

  .right {
    flex: 1;
    position: relative;
    overflow: hidden;

    .title {
      font-weight: 600;
      margin: 5px 0;
    }

    .content {
      color: $gray;
      font-size: 0.75rem !important;
    }
  }
}
</style>
